import styled from 'styled-components';
import HeaderTextBlockOG from '@carvana/showroom-content/TextBlock/Header';
import { getMediaQuery } from '@carvana/showroom-theme';

export const HeaderTextBlockTitle = styled(HeaderTextBlockOG.Title)`
  font-size: 20px;

  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    font-size: 28px !important;
  }

  ${(props) => getMediaQuery(props.theme.breakpoint.lg)} {
    font-size: 36px !important;
  }
`;

export const HeaderTextBlock = styled(HeaderTextBlockOG)`
  flex-direction: column;
`;
